const COMPANIES = {
    listCompanies: "Lista de empresas",
    newCompany: "nova empresa",
    updateCompany: "Atualizar empresa",
    id: "ID",
    name: "Nome",
    ExpiredTo: "Válido até",
    state: "Doença",
    accions: "Ações",

    "delete": "Remover",
    edit: "Editar",
    accept: "Aceitar",
    cancel: "Cancelar",
    update: "Atualizar",

    titleAlert: "Eliminar Empresa:",
    messageAlert: "Esta opção não pode ser desfeita, tem certeza?",

    nit: "Nit",
    addressCompany: "Direção da empresa",
    contactEmail: "email de contato",
    nameCompany: "Nome da empresa",
    personContact: "Pessoa de contato",
    numberMovil: "Número de celular",
    department: "Departamento",
    city: "Cidade",
    contractDate: "data do contrato",
    expiredDate: "Data de expiração",
    languages: "Idioma (localidade)",

    titleCard: "Serviços contratados",
    module: "Módulo",
    yes: "Sim",
    multiForms: "Multiformes",
    subForms: "Subformulários",
    moduleAnswer: "Módulo de resposta",
    dataSource: "Origem dos dados",
    notify: "Notificações",
    connectServi: "Conexão com ServiForms",
    appServi: "Aplicativo ServiForms",
    filterExportData: "Filtro e exportação de dados",
    accessApi: "Acesse os ServiForms da API",
    showCase: "Showcase",
    Bots: "Bots",
    visits: "Visitas",
    Dispatcher: "Dispatcher",

    settingDispatcher: "Configuração do Despachante",
    enterToken: "Insira o token da API",
    EnterUrl: "Digite o URL da API",

    btnCreate: "Para criar",
    btnClean: "Limpar",

    selectedDate: "Selecione a data",

    companies: "Empresas",
    errorQueryCompanies: "Ocorreu um erro ao consultar a lista de Empresas",
    deleteCompany: "Excluir empresas",
    errorDeleteCompany: "Ocorreu um erro ao excluir a empresa",
    actionDisabled: "Ação não disponível no momento",
    company: "Companhia",

    successCompany: "A empresa foi criada.",
    updateSuccess: "A empresa foi atualizada.",
    alertDateExpired: "A data de validade deve ser de no mínimo uma semana."

}

export default { COMPANIES };